import MapComponent from 'components/MapComponent/MapComponent'
import ProfileSidebar from 'components/ProfileSidebar/ProfileSidebar'
import ProfileSetting from 'components/ProfilrSetting/ProfileSetting'
import SideBar from 'components/SideBar/SideBar'
import Wrapper from 'layout/Wrapper/Wrapper'
import React, { useState } from 'react'
import styles from "styles/pages/my-profile.module.scss"

const Myprofile = () => {

    const [Notexpand , setNotExpand] = useState(false)

    function CallBack(params){
        return(
            setNotExpand(params)
        )
    }

    return (
        <div className="main_wraper">
            <Wrapper isHeader={true}>
                <div className={styles.main}>
                    <div className={styles.main_wrapper_flex}>
                        <div className={styles.main_left}>
                            <ProfileSidebar/>
                        </div>
                        <div className={styles.main_rgt}>
                            <ProfileSetting/>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </div>
    )
}

export default Myprofile